import { LocaleCode } from '@/i18n/locales';

export const LOCALE_MAP: Record<LocaleCode, string> = {
  en: 'en-us',
  de: 'de-de',
  es: 'es-es',
  fr: 'fr-fr',
  pt: 'pt-pt',
};
